export default __webpack_public_path__ + "static/media/40t.a2545e8a.jpg";